/*
  Copy a reward code to the clipboard.

  Delegated, so codes rendered later by the theme editor still work. Falls
  back to selecting the text when the clipboard API is unavailable, which is
  the case on http origins and in some in-app browsers.
*/
(function () {
  function flash(button) {
    var hint = button.querySelector('.xp__code-hint');
    if (!hint) return;

    var original = hint.dataset.original || hint.textContent;
    hint.dataset.original = original;
    hint.textContent = button.dataset.copiedLabel || 'Copied';
    button.classList.add('is-copied');

    window.clearTimeout(button._resetTimer);
    button._resetTimer = window.setTimeout(function () {
      hint.textContent = original;
      button.classList.remove('is-copied');
    }, 2000);
  }

  function selectFallback(button) {
    var codeEl = button.querySelector('span');
    if (!codeEl || !window.getSelection || !document.createRange) return;
    var range = document.createRange();
    range.selectNodeContents(codeEl);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-xp-code]');
    if (!button) return;

    var code = button.dataset.xpCode;
    if (!code) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () {
          flash(button);
        },
        function () {
          selectFallback(button);
        }
      );
    } else {
      selectFallback(button);
      flash(button);
    }
  });
})();
